import { message as AntdMessage, Spin } from "antd";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { handleCreateOrganization } from "../../api/auth";
import { getAllIndustryType } from "../../api/industryType";
import FormComponent from "../../component/common/FormComponent";
import { signUpFormFields } from "../../data/SignupFormFields"; // Import the function
import NewLogo from "../../assests/images/qcc_logo.png";
import "./signup.css";
import SignUpStepForm from "../../data/SignUpForm";

const SignUp = () => {
  const [loader, setLoader] = useState(false);
  const [industryTypes, setIndustryTypes] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referrerCode = queryParams.get("referrer_code");

  useEffect(() => {
    const fetchIndustries = async () => {
      setLoader(true);
      const result = await getAllIndustryType(setIndustryTypes);  
      if (!result.success) {
        AntdMessage.error(result.message || "Failed to fetch industry types.");
      }
      setLoader(false);
    };
    fetchIndustries();
  }, []);

  useEffect(() => {
    console.log("Industry types updated state:", industryTypes);
  }, [industryTypes]);
  
  

  // Generate form fields with fetched industry types
  const formFields = signUpFormFields(industryTypes);
  console.log("Form fields generated with industries:", formFields);


  const handleOk = async (values) => {
    const payload = { ...values, refCode: referrerCode || "", industry: values.industry };
    setLoader(true);

    try {
      const { company, message, success, requireVerification } = await handleCreateOrganization(payload);

      if (success) {
        AntdMessage.success(message);
        if (requireVerification) {
          navigate(`/verify/${company?._id}`);
        } else {
          AntdMessage.info("Your account is under review. We will let you know shortly.");
          navigate("/account-under-review");
        }
      } else {
        AntdMessage.error(message);
      }
      return { success }; 
    } catch (error) {
      AntdMessage.error(error?.message);
      return { success: false };
    } finally {
      setLoader(false);
    }
  };
  

  const navigateLogin = () => {
    navigate("/login");
  };

  return (
    <div className="signup-page">
      <div className="login-page">
        <div className="right-section">
          <div className="form-signin">
            <Spin spinning={loader} fullscreen size="large" />

            <div className="logo-container mb-0">
              <img src={NewLogo} onClick={navigateLogin} alt="Collab AI Logo" className="logo" />
            </div>

            <div className="signUp-field-width">
              <SignUpStepForm
                // title="SIGN UP"
                // formItems={formFields}
                // layout="vertical"
                industryTypes={industryTypes}
                handleSubmit={handleOk}
                // className="form mb-4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;